import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const DeleteCourse = async (ID) => {
  try {
    const CourseDocument = doc(db, "Courses", ID);

    await updateDoc(CourseDocument, {
      IsDeleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteCourse;
